import { css } from '@emotion/core';
import { media } from '@domain-group/fe-brary';
export var offMarketCard = /*#__PURE__*/css(media('>=desktop'), "{width:360px;}");
export var featuredArticleCard = /*#__PURE__*/css("margin-top:24px;", media('>=desktop'), "{width:360px;}");